export enum PhasesEditType {
  ADD = 'ADD',
  EDIT = 'EDIT',
  DELETE = 'DELETE'
}
